export const captivate = "captivate";
export const storyline = "storyline";



// WEBPACK FOOTER //
// ./src/constants/courseFormats.js